export default "__VITE_ASSET__CXez3ssh__"